import { render, staticRenderFns } from "./ComBlackWord.vue?vue&type=template&id=6fb6ae7e&scoped=true&"
import script from "./ComBlackWord.vue?vue&type=script&lang=js&"
export * from "./ComBlackWord.vue?vue&type=script&lang=js&"
import style0 from "./ComBlackWord.vue?vue&type=style&index=0&id=6fb6ae7e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb6ae7e",
  null
  
)

export default component.exports